module.exports = __webpack_public_path__ + "img/IT.a8af0707.jpg";